import type { ACCESS_REQUEST_ERROR_CODES } from "@amtana/access-requests-contract";
import type { ErrorCopyFor } from "@amtana/browser";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// What a person reads when asking to join, or deciding on a request, refuses
// (packages/module ADR-001), in English and Spanish.

const EN = {
  notFoundTitle: "This request to join no longer exists",
  notFoundDescription: "It may have already been decided. Reload the list to see.",
  duplicateTitle: "You already asked to join this organization",
  duplicateDescription: "Wait for an admin to decide your existing request.",
  alreadyMemberTitle: "You are already a member",
  alreadyMemberDescription: "You belong to this organization already.",
  cooldownTitle: "Your last request was declined recently",
  cooldownDescription: "Try asking to join this organization again later.",
  rateLimitedTitle: "Too many requests to join",
  rateLimitedDescription: "Try again in a bit.",
  seatsFullTitle: "This organization has no free seat right now",
  seatsFullDescription: "Add a seat to the plan before approving this request.",
} as const;

const ES: Translation<typeof EN> = {
  notFoundTitle: "Esta solicitud ya no existe",
  notFoundDescription: "Puede que ya se haya decidido. Recarga la lista para verlo.",
  duplicateTitle: "Ya pediste unirte a esta organización",
  duplicateDescription: "Espera a que un administrador decida tu solicitud actual.",
  alreadyMemberTitle: "Ya eres miembro",
  alreadyMemberDescription: "Ya perteneces a esta organización.",
  cooldownTitle: "Rechazaron tu última solicitud hace poco",
  cooldownDescription: "Vuelve a pedir unirte a esta organización más adelante.",
  rateLimitedTitle: "Demasiadas solicitudes para unirse",
  rateLimitedDescription: "Inténtalo de nuevo en un rato.",
  seatsFullTitle: "Esta organización no tiene cupos libres por ahora",
  seatsFullDescription: "Agrega un cupo al plan antes de aprobar esta solicitud.",
};

export const ACCESS_REQUEST_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const ACCESS_REQUEST_ERROR_COPY = {
  access_request_not_found: {
    title: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "notFoundDescription"),
  },
  access_request_duplicate: {
    title: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "duplicateTitle"),
    description: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "duplicateDescription"),
  },
  access_request_already_member: {
    title: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "alreadyMemberTitle"),
    description: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "alreadyMemberDescription"),
  },
  access_request_cooldown: {
    title: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "cooldownTitle"),
    description: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "cooldownDescription"),
  },
  access_request_rate_limited: {
    title: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "rateLimitedTitle"),
    description: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "rateLimitedDescription"),
  },
  access_request_seats_full: {
    title: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "seatsFullTitle"),
    description: phrase(ACCESS_REQUEST_ERROR_CATALOGS, "seatsFullDescription"),
  },
} satisfies ErrorCopyFor<typeof ACCESS_REQUEST_ERROR_CODES>;
